import { IComponentOptions } from "angular";
import { ProgressiveDefinitionsDetailMachineEditViewController } from "./controller";

export const vsComponentName =
  "progressiveDefinitionsDetailMachineEditViewComponent";

export const progressiveDefinitionsDetailMachineEditViewComponentOptions: IComponentOptions =
  {
    controller: ProgressiveDefinitionsDetailMachineEditViewController,
    controllerAs: "stateController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      currentProgressiveDefinitionMachines: "<",
      progressiveDefinition: "<",
      date: "<",
    },
  };
